import { STATE_CODES } from '@/constants';
import { BffFacility } from '@/graphql/__generated/sdk';

export const getStateNameByCode = (stateCode: string) => {
	const stateObj = STATE_CODES.find((state) => state.code === stateCode);
	return stateObj ? stateObj.state : '';
};

export const groupedByStates = (facilities: BffFacility[]) => {
	const groups: { [key: string]: BffFacility[] } = {};
	facilities.forEach((facility) => {
		const stateCode = facility.address?.stateCode ?? 'Unknown';
		if (!groups[stateCode]) {
			groups[stateCode] = [];
		}
		groups[stateCode].push(facility);
	});

	return Object.entries(groups)
		.map(([stateCode, facilities]) => ({
			stateCode,
			facilities,
		}))
		.sort((a, b) => a.stateCode.localeCompare(b.stateCode));
};
